<div class="container">
  <div class="container-header">
    <p>Fotos</p>
    <div class="header-btn" (click)="togglePhotoManager(true)">
      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0044 3.414L2.3974 12.021L0.983398 10.607L9.5894 2H2.0044V0H13.0044V11H11.0044V3.414Z" fill="black"/>
      </svg>
    </div>
  </div>
  <p class="info">
    Você pode arrastar as fotos para organizá-las. A ordem que elas aparecem abaixo será a ordem que aparecerão nos sites e portais. A primeira foto será sempre a de destaque.
  </p>
  <div class="upload-content">
    <div class="upload-content-header">
      <input
        #uploadBtnRef
        type="file"
        accept=".jpg,.jpeg,.png,.tiff"
        id="upload-btn-input"
        class="upload-btn"
        multiple
        [disabled]="attachedPhotosSession.length >= maxPhotos"
        (change)="verifyPhotos('button')"
      >
      <label for="upload-btn-input" [ngClass]="{'disabled-input': attachedPhotosSession.length >= maxPhotos}">Carregar fotos</label>
      <div class="mark-all-files" (click)="checkAllPhotos()" *ngIf="!allPhotosChecked">Marcar todas</div>
      <div class="mark-all-files" (click)="uncheckAllPhotos()" *ngIf="hasCheckedPhoto">Desmarcar todas</div>
    </div>
    <div class="upload-content-display">
      <div class="display-grid">
        <div class="empty-grid" [ngClass]="{'hide-grid-btn': attachedPhotosSession.length > 0}">
          <input
            #gridUploadBtnRef
            type="file"
            accept=".jpg,.jpeg,.png,.tiff"
            id="grid-upload-btn-input"
            class="grid-upload-btn"
            multiple
            (change)="verifyPhotos('grid')"
          >
          <label for="grid-upload-btn-input">Clique para carregar os arquivos</label>
        </div>
        <div class="files-grid">
          <div class="files-grid-display" *ngFor="let file of attachedPhotosSession; let j = index" [title]="file.name">
            <div class="filetype-document" *ngIf="file.icon">
              <img class="svg-icon" src="../../../../assets/svgs/{{ file.icon }}.svg" alt="icone_documento">
              <span>{{ file.fileExt }}</span>
            </div>
            <div class="filetype-document" *ngIf="!file.icon">
              <img class="thumb" [src]="file.content" alt="{{ file.name }}">
              <div class="thumb-overlay"></div>
            </div>
            <div class="more-btn" (click)="file.showActions = true" title="">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z" fill="white"/>
              </svg>
            </div>
            <div class="mark just-hover" (click)="file.marked = true" *ngIf="!file.marked && j !== 0" title="Marcar foto">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z" fill="white"/>
              </svg>
            </div>
            <div class="mark" (click)="file.marked = false" *ngIf="file.marked && j !== 0" title="Desmarcar foto">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"/>
              </svg>
            </div>
            <div class="spotlight" *ngIf="j === 0">
              <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26Z" fill="#E3C210"/>
              </svg>
            </div>
            <div class="file-position" title="">
              <span>{{ j + 1 }}</span>
            </div>
            <div class="dropdown-backdrop" *ngIf="file.showActions" (click)="file.showActions = false"></div>
            <div class="actions-dropdown" *ngIf="file.showActions" title="">
              <div class="action-item" (click)="file.showActions = false; file.showClassify = true;">
                <span>Classificar</span>
                <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.752 0.000108686C0.826667 0.000108683 0.890667 0.0321083 0.944 0.0961084L5.12 4.25611C5.17333 4.30944 5.2 4.37878 5.2 4.46411C5.2 4.54944 5.17333 4.61344 5.12 4.65611L0.944 8.81611C0.890667 8.88011 0.826667 8.91211 0.752001 8.91211C0.677334 8.91211 0.608001 8.88011 0.544001 8.81611L0.0960006 8.36811C0.0320005 8.31478 -2.89078e-08 8.25078 -3.21716e-08 8.17611C-3.54354e-08 8.10144 0.0320005 8.03211 0.0960006 7.96811L3.6 4.46411L0.0960003 0.944109C0.0320002 0.890776 -3.53654e-07 0.821443 -3.57384e-07 0.736109C-3.61114e-07 0.650775 0.0320002 0.586775 0.0960003 0.544108L0.544 0.0961084C0.597334 0.0321083 0.666667 0.00010869 0.752 0.000108686Z" fill="#6F6F6F"/>
                </svg>
              </div>
              <div class="action-item" (click)="file.showActions = false; file.showReorder = true;">
                <span>Posicionar</span>
                <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.752 0.000108686C0.826667 0.000108683 0.890667 0.0321083 0.944 0.0961084L5.12 4.25611C5.17333 4.30944 5.2 4.37878 5.2 4.46411C5.2 4.54944 5.17333 4.61344 5.12 4.65611L0.944 8.81611C0.890667 8.88011 0.826667 8.91211 0.752001 8.91211C0.677334 8.91211 0.608001 8.88011 0.544001 8.81611L0.0960006 8.36811C0.0320005 8.31478 -2.89078e-08 8.25078 -3.21716e-08 8.17611C-3.54354e-08 8.10144 0.0320005 8.03211 0.0960006 7.96811L3.6 4.46411L0.0960003 0.944109C0.0320002 0.890776 -3.53654e-07 0.821443 -3.57384e-07 0.736109C-3.61114e-07 0.650775 0.0320002 0.586775 0.0960003 0.544108L0.544 0.0961084C0.597334 0.0321083 0.666667 0.00010869 0.752 0.000108686Z" fill="#6F6F6F"/>
                </svg>
              </div>
              <div class="action-item" (click)="file.showActions = false;">
                <span>Ver foto</span>
              </div>
              <div class="action-item" (click)="file.showActions = false; removeAttachedPhoto(j)">
                <span>Excluir</span>
              </div>
            </div>
            <div class="dropdown-backdrop" *ngIf="file.showClassify" (click)="file.showClassify = false"></div>
            <div class="classify-dropdown" *ngIf="file.showClassify" title="">
              <div class="classify-item" *ngFor="let type of mockClassification" (click)="file.showClassify = false;">
                <span>{{ type }}</span>
              </div>
            </div>
            <div class="dropdown-backdrop" *ngIf="file.showReorder" (click)="file.showReorder = false"></div>
            <div class="reorder-dropdown" *ngIf="file.showReorder" title="">
              <div class="reorder-item" *ngFor="let position of mockReorder" (click)="file.showReorder = false;">
                <span>{{ position }}</span>
              </div>
            </div>
          </div>
          <div class="files-grid-display-btn" title="adicionar foto" [ngClass]="{'hide-grid-btn': attachedPhotosSession.length < 1 || attachedPhotosSession.length >= maxPhotos}">
            <input
              #gridUploadBtn2Ref
              type="file"
              accept=".jpg,.jpeg,.png,.tiff"
              id="grid-upload-btn2-input"
              class="grid-upload-btn2"
              multiple
              (change)="verifyPhotos('grid2')"
            >
            <label for="grid-upload-btn2-input">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.9678 1.06823H8.97376V8.97368H1.06831V10.9677H8.97376V18.8732H10.9678V10.9677H18.8733V8.97368H10.9678V1.06823Z" fill="#ACACAC"/>
              </svg>
            </label>
          </div>
        </div>
      </div>
      <p>Mínimo de arquivos requeridos: 15</p>
    </div>
  </div>
</div>
<div class="container">
  <div class="container-header">
    <p>Outras mídias</p>
  </div>
  <div class="url-form" *ngFor="let video of videosArray; let j = index">
    <app-input
      class="input-control"
      [label]="'Vídeo (url)'"
      [placeholder]="'https://'"
      [(ngModel)]="videosArray[j].url"
    ></app-input>
    <button (click)="openUrl(video.url)">
      <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9997 0C16.3917 0 20.8777 3.88 21.8187 9C20.8787 14.12 16.3917 18 10.9997 18C5.60766 18 1.12166 14.12 0.180664 9C1.12066 3.88 5.60766 0 10.9997 0ZM10.9997 16C13.0391 15.9996 15.0181 15.3068 16.6125 14.0352C18.207 12.7635 19.3226 10.9883 19.7767 9C19.3209 7.0133 18.2046 5.24 16.6103 3.97003C15.016 2.70005 13.038 2.00853 10.9997 2.00853C8.96136 2.00853 6.98335 2.70005 5.38904 3.97003C3.79473 5.24 2.67843 7.0133 2.22266 9C2.67676 10.9883 3.79234 12.7635 5.38681 14.0352C6.98128 15.3068 8.9602 15.9996 10.9997 16ZM10.9997 13.5C9.80619 13.5 8.6616 13.0259 7.81768 12.182C6.97377 11.3381 6.49966 10.1935 6.49966 9C6.49966 7.80653 6.97377 6.66193 7.81768 5.81802C8.6616 4.97411 9.80619 4.5 10.9997 4.5C12.1931 4.5 13.3377 4.97411 14.1816 5.81802C15.0256 6.66193 15.4997 7.80653 15.4997 9C15.4997 10.1935 15.0256 11.3381 14.1816 12.182C13.3377 13.0259 12.1931 13.5 10.9997 13.5ZM10.9997 11.5C11.6627 11.5 12.2986 11.2366 12.7674 10.7678C13.2363 10.2989 13.4997 9.66304 13.4997 9C13.4997 8.33696 13.2363 7.70107 12.7674 7.23223C12.2986 6.76339 11.6627 6.5 10.9997 6.5C10.3366 6.5 9.70074 6.76339 9.2319 7.23223C8.76306 7.70107 8.49966 8.33696 8.49966 9C8.49966 9.66304 8.76306 10.2989 9.2319 10.7678C9.70074 11.2366 10.3366 11.5 10.9997 11.5Z" fill="black"/>
      </svg>
    </button>
    <button (click)="removeVideoUrl(j)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z" fill="black"/>
      </svg>
    </button>
  </div>
  <div class="add-url-btn" (click)="addVideo()">Adicionar vídeo (url)</div>
  <div class="url-form" *ngFor="let tour of toursArray; let k = index">
    <app-input
      class="input-control"
      [label]="'Tour virtual (url)'"
      [placeholder]="'https://'"
      [(ngModel)]="toursArray[k].url"
    ></app-input>
    <button (click)="openUrl(tour.url)">
      <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9997 0C16.3917 0 20.8777 3.88 21.8187 9C20.8787 14.12 16.3917 18 10.9997 18C5.60766 18 1.12166 14.12 0.180664 9C1.12066 3.88 5.60766 0 10.9997 0ZM10.9997 16C13.0391 15.9996 15.0181 15.3068 16.6125 14.0352C18.207 12.7635 19.3226 10.9883 19.7767 9C19.3209 7.0133 18.2046 5.24 16.6103 3.97003C15.016 2.70005 13.038 2.00853 10.9997 2.00853C8.96136 2.00853 6.98335 2.70005 5.38904 3.97003C3.79473 5.24 2.67843 7.0133 2.22266 9C2.67676 10.9883 3.79234 12.7635 5.38681 14.0352C6.98128 15.3068 8.9602 15.9996 10.9997 16ZM10.9997 13.5C9.80619 13.5 8.6616 13.0259 7.81768 12.182C6.97377 11.3381 6.49966 10.1935 6.49966 9C6.49966 7.80653 6.97377 6.66193 7.81768 5.81802C8.6616 4.97411 9.80619 4.5 10.9997 4.5C12.1931 4.5 13.3377 4.97411 14.1816 5.81802C15.0256 6.66193 15.4997 7.80653 15.4997 9C15.4997 10.1935 15.0256 11.3381 14.1816 12.182C13.3377 13.0259 12.1931 13.5 10.9997 13.5ZM10.9997 11.5C11.6627 11.5 12.2986 11.2366 12.7674 10.7678C13.2363 10.2989 13.4997 9.66304 13.4997 9C13.4997 8.33696 13.2363 7.70107 12.7674 7.23223C12.2986 6.76339 11.6627 6.5 10.9997 6.5C10.3366 6.5 9.70074 6.76339 9.2319 7.23223C8.76306 7.70107 8.49966 8.33696 8.49966 9C8.49966 9.66304 8.76306 10.2989 9.2319 10.7678C9.70074 11.2366 10.3366 11.5 10.9997 11.5Z" fill="black"/>
      </svg>
    </button>
    <button (click)="removeTourUrl(k)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z" fill="black"/>
      </svg>
    </button>
  </div>
  <div class="add-url-btn" (click)="addTour()">Adicionar tour virtual (url)</div>
</div>
<div class="container">
  <div class="container-header">
    <p>Anexos</p>
  </div>
  <div class="upload-content">
    <div class="upload-content-header">
      <input
        #uploadFileBtnRef
        type="file"
        accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx"
        id="upload-file-btn-input"
        class="upload-btn"
        multiple
        [disabled]="attachedFilesSession.length >= maxFiles"
        (change)="verifyFiles('button')"
      >
      <label for="upload-file-btn-input" [ngClass]="{'disabled-input': attachedFilesSession.length >= maxFiles}">Carregar arquivos</label>
    </div>
    <div class="upload-content-display">
      <div class="display-grid">
        <div class="empty-grid" [ngClass]="{'hide-grid-btn': attachedFilesSession.length > 0}">
          <input
            #gridUploadFileBtnRef
            type="file"
            accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx"
            id="grid-upload-file-btn-input"
            class="grid-upload-btn"
            multiple
            (change)="verifyFiles('grid')"
          >
          <label for="grid-upload-file-btn-input">Clique para carregar os arquivos</label>
        </div>
        <div class="files-grid">
          <div class="files-grid-display" *ngFor="let file of attachedFilesSession; let j = index" [title]="file.name">
            <div class="filetype-document" *ngIf="file.icon">
              <img class="svg-icon" src="../../../../assets/svgs/{{ file.icon }}.svg" alt="icone_documento">
              <span>{{ file.fileExt }}</span>
            </div>
            <div class="filetype-document" *ngIf="!file.icon">
              <img class="thumb" [src]="file.content" alt="{{ file.name }}">
              <div class="thumb-overlay"></div>
            </div>
          </div>
          <div class="files-grid-display-btn" title="adicionar arquivo" [ngClass]="{'hide-grid-btn': attachedFilesSession.length < 1 || attachedFilesSession.length >= maxFiles}">
            <input
              #gridUploadFileBtn2Ref
              type="file"
              accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx"
              id="grid-upload-file-btn2-input"
              class="grid-upload-btn2"
              multiple
              (change)="verifyFiles('grid2')"
            >
            <label for="grid-upload-file-btn2-input">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.9678 1.06823H8.97376V8.97368H1.06831V10.9677H8.97376V18.8732H10.9678V10.9677H18.8733V8.97368H10.9678V1.06823Z" fill="#ACACAC"/>
              </svg>
            </label>
          </div>
        </div>
      </div>
      <p>Máximo de arquivos permitidos: 09</p>
      <p>Tamanho máximo dos arquivos: 2 MB</p>
    </div>
  </div>
</div>
<div class="footer">
  <lib-button-tertiary class="cancel-btn">Cancelar</lib-button-tertiary>
  <lib-button-primary>Salvar</lib-button-primary>
</div>

<div class="photos-full" [ngClass]="{'show': showFullPhotoManager}">
  <div class="container full">
    <div class="container-header full">
      <p>Fotos</p>
      <div class="header-btn" (click)="togglePhotoManager(false)">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black"/>
        </svg>
      </div>
    </div>
    <p class="info">
      Você pode arrastar as fotos para organizá-las. A ordem que elas aparecem abaixo será a ordem que aparecerão nos sites e portais. A primeira foto será sempre a de destaque.
    </p>
    <div class="upload-content">
      <div class="upload-content-header">
        <input
          #uploadBtnRefFull
          type="file"
          accept=".jpg,.jpeg,.png,.tiff"
          id="upload-btn-input"
          class="upload-btn"
          multiple
          [disabled]="attachedPhotosSession.length >= maxPhotos"
          (change)="verifyPhotos('button')"
        >
        <label for="upload-btn-input" [ngClass]="{'disabled-input': attachedPhotosSession.length >= maxPhotos}">Carregar fotos</label>
        <div class="mark-all-files" (click)="checkAllPhotos()" *ngIf="!allPhotosChecked">Marcar todas</div>
        <div class="mark-all-files" (click)="uncheckAllPhotos()" *ngIf="hasCheckedPhoto">Desmarcar todas</div>
      </div>
      <div class="upload-content-display">
        <div class="display-grid full">
          <div class="empty-grid" [ngClass]="{'hide-grid-btn': attachedPhotosSession.length > 0}">
            <input
              #gridUploadBtnRefFull
              type="file"
              accept=".jpg,.jpeg,.png,.tiff"
              id="grid-upload-btn-input"
              class="grid-upload-btn"
              multiple
              (change)="verifyPhotos('grid')"
            >
            <label for="grid-upload-btn-input">Clique para carregar os arquivos</label>
          </div>
          <div class="files-grid">
            <div class="files-grid-display full" *ngFor="let file of attachedPhotosSession; let j = index" [title]="file.name">
              <div class="filetype-document" *ngIf="file.icon">
                <img class="svg-icon" src="../../../../assets/svgs/{{ file.icon }}.svg" alt="icone_documento">
                <span>{{ file.fileExt }}</span>
              </div>
              <div class="filetype-document" *ngIf="!file.icon">
                <img class="thumb" [src]="file.content" alt="{{ file.name }}">
                <div class="thumb-overlay"></div>
              </div>
              <div class="more-btn" (click)="file.showActions = true" title="">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z" fill="white"/>
                </svg>
              </div>
              <div class="mark just-hover" (click)="file.marked = true" *ngIf="!file.marked && j !== 0" title="Marcar foto">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z" fill="white"/>
                </svg>
              </div>
              <div class="mark" (click)="file.marked = false" *ngIf="file.marked && j !== 0" title="Desmarcar foto">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"/>
                </svg>
              </div>
              <div class="spotlight" *ngIf="j === 0">
                <svg width="37" height="34" viewBox="0 0 37 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.5003 27.39L7.62694 33.312L10.0551 21.42L0.905273 13.188L13.2802 11.76L18.5003 0.75L23.7204 11.76L36.0954 13.188L26.9456 21.42L29.3737 33.312L18.5003 27.39Z" fill="#E3C210"/>
                </svg>
              </div>
              <div class="file-position" title="">
                <span>{{ j + 1 }}</span>
              </div>
              <div class="dropdown-backdrop" *ngIf="file.showActions" (click)="file.showActions = false"></div>
              <div class="actions-dropdown" *ngIf="file.showActions" title="">
                <div class="action-item" (click)="file.showActions = false; file.showClassify = true;">
                  <span>Classificar</span>
                  <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.752 0.000108686C0.826667 0.000108683 0.890667 0.0321083 0.944 0.0961084L5.12 4.25611C5.17333 4.30944 5.2 4.37878 5.2 4.46411C5.2 4.54944 5.17333 4.61344 5.12 4.65611L0.944 8.81611C0.890667 8.88011 0.826667 8.91211 0.752001 8.91211C0.677334 8.91211 0.608001 8.88011 0.544001 8.81611L0.0960006 8.36811C0.0320005 8.31478 -2.89078e-08 8.25078 -3.21716e-08 8.17611C-3.54354e-08 8.10144 0.0320005 8.03211 0.0960006 7.96811L3.6 4.46411L0.0960003 0.944109C0.0320002 0.890776 -3.53654e-07 0.821443 -3.57384e-07 0.736109C-3.61114e-07 0.650775 0.0320002 0.586775 0.0960003 0.544108L0.544 0.0961084C0.597334 0.0321083 0.666667 0.00010869 0.752 0.000108686Z" fill="#6F6F6F"/>
                  </svg>
                </div>
                <div class="action-item" (click)="file.showActions = false; file.showReorder = true;">
                  <span>Posicionar</span>
                  <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.752 0.000108686C0.826667 0.000108683 0.890667 0.0321083 0.944 0.0961084L5.12 4.25611C5.17333 4.30944 5.2 4.37878 5.2 4.46411C5.2 4.54944 5.17333 4.61344 5.12 4.65611L0.944 8.81611C0.890667 8.88011 0.826667 8.91211 0.752001 8.91211C0.677334 8.91211 0.608001 8.88011 0.544001 8.81611L0.0960006 8.36811C0.0320005 8.31478 -2.89078e-08 8.25078 -3.21716e-08 8.17611C-3.54354e-08 8.10144 0.0320005 8.03211 0.0960006 7.96811L3.6 4.46411L0.0960003 0.944109C0.0320002 0.890776 -3.53654e-07 0.821443 -3.57384e-07 0.736109C-3.61114e-07 0.650775 0.0320002 0.586775 0.0960003 0.544108L0.544 0.0961084C0.597334 0.0321083 0.666667 0.00010869 0.752 0.000108686Z" fill="#6F6F6F"/>
                  </svg>
                </div>
                <div class="action-item" (click)="file.showActions = false;">
                  <span>Ver foto</span>
                </div>
                <div class="action-item" (click)="file.showActions = false; removeAttachedPhoto(j)">
                  <span>Excluir</span>
                </div>
              </div>
              <div class="dropdown-backdrop" *ngIf="file.showClassify" (click)="file.showClassify = false"></div>
              <div class="classify-dropdown" *ngIf="file.showClassify" title="">
                <div class="classify-item" *ngFor="let type of mockClassification" (click)="file.showClassify = false;">
                  <span>{{ type }}</span>
                </div>
              </div>
              <div class="dropdown-backdrop" *ngIf="file.showReorder" (click)="file.showReorder = false"></div>
              <div class="reorder-dropdown" *ngIf="file.showReorder" title="">
                <div class="reorder-item" *ngFor="let position of mockReorder" (click)="file.showReorder = false;">
                  <span>{{ position }}</span>
                </div>
              </div>
            </div>
            <div class="files-grid-display-btn full" title="adicionar foto" [ngClass]="{'hide-grid-btn': attachedPhotosSession.length < 1 || attachedPhotosSession.length >= maxPhotos}">
              <input
                #gridUploadBtn2RefFull
                type="file"
                accept=".jpg,.jpeg,.png,.tiff"
                id="grid-upload-btn2-input"
                class="grid-upload-btn2"
                multiple
                (change)="verifyPhotos('grid2')"
              >
              <label for="grid-upload-btn2-input">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9678 1.06823H8.97376V8.97368H1.06831V10.9677H8.97376V18.8732H10.9678V10.9677H18.8733V8.97368H10.9678V1.06823Z" fill="#ACACAC"/>
                </svg>
              </label>
            </div>
          </div>
        </div>
        <p>Mínimo de arquivos requeridos: 15</p>
      </div>
    </div>
  </div>
</div>